import { hideFullScreenOverlay, showFullScreenOverlay } from '../../layout/fullScreenOverlay';
import { acceptPolicy, AcceptPolicyRequest } from '../policy/acceptPolicyRequest';
import { getUserSuid } from './getUserSuid';
import { AcceptPolicyResponse } from '../../api/hub-responses/accept-policy-response';

type PolicyInfo = {
    accepted: boolean,
    html_view: string,
    unacceptable_ids: {[key: string]: number},
    isNotification: boolean
};


export const PolicyDialog = {
    $current_policy_popup: void (0) as JQuery<HTMLElement>,
    block_button: void (0) as boolean,
    policyInfo: void (0) as PolicyInfo,
    $accept_policy_popup: $('#accept_policy_popup'),
    $notify_policy_popup: $('#notify_policy_popup'),
    setGetUserReadyFlag: (): void => {
        window.app.flags.get_user_ready = true;
    },
    checkPolicyAccept: (): void => {
        PolicyDialog.policyInfo = window.app.getGameStartDataResponse.policy_info as unknown as PolicyInfo;
        delete window.app.getGameStartDataResponse.policy_info;

        PolicyDialog.$current_policy_popup = PolicyDialog.policyInfo.isNotification === true
            ? PolicyDialog.$notify_policy_popup
            : PolicyDialog.$accept_policy_popup;

        if (PolicyDialog.policyInfo.accepted === true) {
            PolicyDialog.setGetUserReadyFlag();
            return;
        }

        $('button', PolicyDialog.$current_policy_popup).on('click', () => {
            if (
                typeof PolicyDialog.block_button === 'undefined' ||
                PolicyDialog.block_button === false
            ) {
                PolicyDialog.block_button = true;
                PolicyDialog.acceptNewPolicy(this);
            }
        });

        $('.content', PolicyDialog.$current_policy_popup).html(PolicyDialog.policyInfo.html_view);
        PolicyDialog.$current_policy_popup.show();
        if (PolicyDialog.policyInfo.isNotification === true) {
            PolicyDialog.setGetUserReadyFlag();
            showFullScreenOverlay();
        }
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    acceptNewPolicy: async(_button: any) => {
        let key: string;
        let id;
        const policyIds = [];

        for (key in PolicyDialog.policyInfo.unacceptable_ids) {
            id = PolicyDialog.policyInfo.unacceptable_ids[key];
            policyIds.push(id);
        }

        const data: AcceptPolicyRequest = {
            suid: getUserSuid(false),
            token: window.app.config.user_auth_token,
            policy_ids: policyIds
        };

        let errorText = 'bad response from server. response: ';
        try {
            const response: AcceptPolicyResponse = await acceptPolicy(data);

            if (response.status !== 1) {
                errorText += JSON.stringify(response);
                window.Sentry.captureException(new Error(errorText));
            }
        } catch (error) {
            errorText += JSON.stringify(error);
            window.Sentry.captureException(new Error(errorText));
        } finally {
            PolicyDialog.setGetUserReadyFlag();
            PolicyDialog.$current_policy_popup.hide();
            hideFullScreenOverlay();
        }
    }
};

$(() => {
    PolicyDialog.$accept_policy_popup = $('#accept_policy_popup');
    PolicyDialog.$notify_policy_popup = $('#notify_policy_popup');
});
